import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/customers/banners')({
  staticData: {
    crumb: 'route.customers.banners',
    title: 'route.customers.banners',
    permissions: ['customers_banners_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
